
import React, { useEffect, useState } from 'react';
import OnboardingHR from './OnboardingHR';
import DynamicOnboardingEmployee from './DynamicOnboardingEmployee';

const Onboarding = () => {
    const [userRole, setUserRole] = useState(null);
    const [userData, setUserData] = useState(null);

    useEffect(() => {
        const token = localStorage.getItem('zTaskAuthToken');
        if (!token) return;

        try {
            // Decode Token
            const base64Url = token.split('.')[1];
            const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
            const jsonPayload = decodeURIComponent(window.atob(base64).split('').map(function (c) {
                return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
            }).join(''));

            const payload = JSON.parse(jsonPayload);
            setUserData(payload);

            // Extract Roles safely
            const rolesRaw = payload.claims?.roles || payload.roles || [];
            // Convert to array of uppercase strings for safe comparison
            const roles = (Array.isArray(rolesRaw) ? rolesRaw : [rolesRaw]).map(r => r.toString().toUpperCase());

            const designation = payload.claims?.designation || '';

            // --- LOGIC: Allow HR or ADMIN to see the HR Dashboard ---
            if (roles.includes('HR') || roles.includes('ADMIN') || roles.includes('SUPER_ADMIN') || designation === 'HR') {
                setUserRole('HR');
            } else {
                setUserRole('EMPLOYEE');
            }

        } catch (e) {
            console.error("Failed to decode token", e);
            setUserRole('EMPLOYEE');
        }
    }, []);

    if (!userRole) {
        return <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh', color: '#64748B' }}>Loading...</div>;
    }

    return (
        <>
            {userRole === 'HR' ? (
                <OnboardingHR />
            ) : (
                <DynamicOnboardingEmployee user={{
                    user_ID: userData?.claims?.user_ID || userData?.user_id || userData?.id,
                    name: userData?.sub || userData?.claims?.name
                }} />
            )}
        </>
    );
};

export default Onboarding;